import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';
import { CompanyOffer, DraftCompanyOffer } from 'src/features/companyOffers/companyOffers.types';

const companyOffersApiPath = (companyId: string) => `/companies/${companyId}/offers`;

export const getOffers = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyOffer[] & ApiError>> => {
  return instance
    .get<CompanyOffer[]>(companyOffersApiPath(companyId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const createOffer = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: DraftCompanyOffer;
}): Promise<AxiosResponse<CompanyOffer & ApiError>> => {
  return instance
    .post<CompanyOffer>(companyOffersApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyOfferApiPath = (companyId: string, code: string) => `/companies/${companyId}/offers/${code}`;

export const deleteOffer = async ({
  companyId,
  code,
}: {
  companyId: string;
  code: string;
}): Promise<AxiosResponse<CompanyOffer & ApiError>> => {
  return instance
    .delete<CompanyOffer>(companyOfferApiPath(companyId, code))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateOffer = async ({
  companyId,
  code,
  data,
}: {
  companyId: string;
  code: string;
  data: Partial<DraftCompanyOffer>;
}): Promise<AxiosResponse<CompanyOffer & ApiError>> => {
  return instance
    .post<CompanyOffer>(companyOfferApiPath(companyId, code), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};
